import { useIntl } from 'react-intl';

export function integerValidator(value: string, options: { message: string }) {
    const message = options.message;
    return /^[0-9]*$/.test(value) ? '' : message;
}

export function useIntegerValidator() {
    const intl = useIntl();
    const defaultMessage = intl.formatMessage({
        id: 'tsk_onboarding_validation_positive_integer',
    });
    return (value: string, options?: { message?: string }) =>
        integerValidator(value, { message: defaultMessage, ...options });
}
